import React from 'react'
import { render as renderDOM } from 'react-dom'
import { rehydrate } from 'fela-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { LastLocationProvider } from 'react-router-last-location'
import store, { history } from 'store'
import { initSimpleImg } from 'react-simple-img'
import { RendererProvider as FelaProvider, ThemeProvider } from 'react-fela'
import ConnectedIntl from 'views/components/providers/ConnectedIntl'
import createRenderer from 'views/styles/renderer'
import 'assets/css/main.css'
import App from 'views/layouts/App'
import Validators from 'redux-form-validators'
import { FormattedMessage } from 'react-intl'
import Modal from 'react-modal'
import 'utils/polyfills'
import { ConfigProvider as AntConfigProvider } from 'antd'
import { antdTheme } from './views/styles/antdTheme'
import { tokens } from './views/styles/designSystem'
import { BrowserRouter } from 'react-router-dom'

const rootEl = document.querySelector('#app')

// Bind modal to our appElement
Modal.setAppElement('#app')

// Render base styles
const renderer = createRenderer()
rehydrate(renderer)

// Set lazyloaded images
initSimpleImg({
  threshold: [0.25], // load image when 25 percentage of it is in the viewport
})

// Set i18n
Validators.formatMessage = (msg) => <FormattedMessage {...(msg.props || msg)} /> // eslint-disable-line

renderDOM(
  <ReduxProvider store={store}>
    <FelaProvider renderer={renderer}>
      <ConnectedIntl>
        <BrowserRouter history={history}>
          <LastLocationProvider>
            <ThemeProvider theme={tokens}>
              <AntConfigProvider theme={antdTheme}>
                <App />
              </AntConfigProvider>
            </ThemeProvider>
          </LastLocationProvider>
        </BrowserRouter>
      </ConnectedIntl>
    </FelaProvider>
  </ReduxProvider>,
  rootEl,
)
